import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import { getPaymentMethod, fetchPaymentMethod } from '../../../store/client'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Radio from '@material-ui/core/Radio'

const styles = theme => ({
  root: {
  },
  courseTitle: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 600
  },
  detailLabel: {
    fontSize: theme.typography.body2.fontSize,
    color: '#888'
  },
  detailValue: {
  },
  providerCard: {
    //padding: theme.spacing.unit * 2,    
  },
  providerCardAvatar: {
    width: theme.spacing(8),
    height: theme.spacing(8),    
  },
  providerCardName: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 600,
  },
})

const PaymentMethodForm = ({ theme, classes, formData, onChange, publicClass, paymentMethod,fetchPaymentMethod, user, ...props }) => {

  useEffect(() => {
      fetchPaymentMethod(publicClass.uid)
  },[])

  const onChangePayment = value => {
      onChange(value)
  }
  
  return (
    <Box>
      { paymentMethod.lastFetched && paymentMethod.data.length > 0 && paymentMethod.data.map(item =>
        <>
        { item.name !== 'Credit Card' &&      
          <Box 
            style={
              {
                border: formData.payment_method === item.code ? '2px solid #3f51b5' : '1px solid #ccc', 
                display:'flex', flexDirection:'row', 
                cursor:'pointer'
              }
            } 
            mt={1} 
            onClick={() => onChangePayment(item.code)}
            >
            <Radio
                checked={formData.payment_method === item.code}
                value={item.code}
                name="radio-button-demo"
                color='primary'
            />
            <Box style={{padding:'8px'}}>
                <Typography variant='body1'>
                  {item.name}
                </Typography>

                { item.name === 'Bank Transfer' &&
                  <img 
                    src='http://media.marketwire.com/attachments/201709/104229_PT.-Bank-Central-Asia-Tbk-1200px-logo.jpg' 
                    style={{width:'20%', padding:'8px'}}
                    />
                }

                { item.name === 'Credit Card' &&
                  <img 
                    src='https://internationalawards.net/catalog/view/theme/default/image/tild3264-3865-4136-a463-626236353037__601545.png' 
                    style={{width:'40%', padding:'8px'}}
                    />
                }
                
            </Box>
          </Box>
        }
        </>
      )}
  </Box>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {   
    paymentMethod: getPaymentMethod(state,ownProps.publicClass.uid)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchPaymentMethod: (key) => {
        dispatch(fetchPaymentMethod(key))
    },
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(PaymentMethodForm)
)
